<template>
    <time :datetime="date.formatIf(datetime, '')">{{ date.formatIf(display, '-') }}</time>
</template>

<script>
import dayjs from 'dayjs';

export default {
    name: 'TimeDisplay',
    props: {
        date: {
            type: dayjs,
            required: true,
        },
        showDate: {
            type: Boolean,
            default: true,
        },
        showTime: {
            type: Boolean,
            default: true,
        },
        dateFormat: {
            type: String,
            default: 'dd, DD.MM.YYYY',
        },
        timeFormat: {
            type: String,
            default: 'HH:mm',
        },
    },

    computed: {
        display() {
            let formats = [];
            if (this.showDate) {
                formats.push(this.dateFormat);
            }
            if (this.showTime) {
                formats.push(this.timeFormat);
            }
            return formats.join(' ');
        },
        datetime() {
            let formats = [];
            if (this.showDate) {
                formats.push('YYYY-MM-DD');
            }
            if (this.showTime) {
                formats.push('HH:mm');
            }
            return formats.join(' ');
        },
    },
};
</script>
